
import { defineComponent, onMounted } from 'vue';
import AppButton from '@/components/UI/AppButton.vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: { AppButton },
  setup() {
    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {};
  },
});
